import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { LocalStorageService } from 'shared/services/local-storage.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import firebase from 'firebase/app';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AngularFireAuth,
              private snackBar: MatSnackBar,
              private storageService: LocalStorageService,
              private router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {

    return this.authService.user
      .pipe(
        switchMap(user => {
          if (!user) {
            return of(null);
          }
          return user.getIdTokenResult();
        }),
        map((idTokenResult: firebase.auth.IdTokenResult | null) => {
          if (!idTokenResult || idTokenResult === null) {
            this.router.navigateByUrl('login').then()
            return false;
          } else {
            const userRole = idTokenResult?.claims?.role;
            const organizationId = idTokenResult?.claims?.organizationId;
            if ((userRole === 'technician') || (userRole === 'contractor')) {
              this.router.navigateByUrl('no-access').then()
              return false;
            }
            if ((userRole === 'contact')) {
              // ToDo: This need to route to client section
              this.router.navigateByUrl('client').then()
              return false;
            }
            if ((userRole !== 'admin') && (userRole !== 'manager') || !organizationId) {
              //ToDo: translate this snackbar message: might have to do manually since no html file here.
              this.snackBar
                .open('Access Denied', 'You must be an admin to login to this app', {
                  duration: 3000
                });
              this.router.navigateByUrl('signout').then()
              return false;
            }
          }
          return true;
        })
      );
  }

}
